/* src/app/components/TextAdornment/index.js */

import React from 'react';
import PropTypes from 'prop-types';

import { withStyles } from '@material-ui/core/styles';
import { Typography } from '@material-ui/core';
import styles from './styles';

const TextAdornment = ({ classes, Adornment, text, subtext }) => (
  <div className={classes.container}>
    <Adornment />
    <div className={classes.textWrapper}>
      <Typography>{text}</Typography>
      <Typography>{subtext}</Typography>
    </div>
  </div>
);

TextAdornment.propTypes = {
  classes: PropTypes.object.isRequired,
  Adornment: PropTypes.any.isRequired,
  text: PropTypes.string.isRequired,
  subtext: PropTypes.string,
};

TextAdornment.defaultProps = {
  subtext: '',
};

export default withStyles(styles)(TextAdornment);



// WEBPACK FOOTER //
// ./src/app/components/TextAdornment/index.js